export const ANON_ID_KEY = 'zoe_anon_id';

let memoryId: string | null = null;

/** Guarded so getAnonId can never throw. */
function mint(): string {
  try {
    return crypto.randomUUID();
  } catch {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/** Storage access throws in Safari private mode and under blocked-cookie settings, so every access is guarded. */
export function getAnonId(): string {
  if (memoryId) return memoryId;
  try {
    const existing = localStorage.getItem(ANON_ID_KEY);
    if (existing) {
      memoryId = existing;
      return existing;
    }
  } catch {
    // Fall through to mint
  }
  const id = mint();
  memoryId = id;
  try {
    localStorage.setItem(ANON_ID_KEY, id);
  } catch {
    // in-memory only for this session
  }
  return id;
}

/** Test helper — clears the module-scoped cache. */
export function _resetIdentity(): void {
  memoryId = null;
}
